export default __webpack_public_path__ + "static/media/SearchIcon.b7f69ce2.svg";